import { Checkbox, ListItem, ListItemButton } from "@mui/material";

import { EVOTRUX_BLUE_LIGHT } from "constants/index";

import type { ReactNode } from "react";

interface Props {
  checked: boolean;
  indeterminate?: boolean;
  selected?: boolean;
  ariaLabel: string;
  onClick: VoidFunction;
  children: ReactNode;
}

// One row shape for "Select all" and every teammate, so their checkboxes line up.
export function CheckableRow(props: Props) {
  const {
    checked,
    indeterminate = false,
    selected = false,
    ariaLabel,
    onClick,
    children,
  } = props;

  return (
    <ListItem disablePadding>
      <ListItemButton
        selected={selected}
        onClick={onClick}
        sx={{
          gap: 1.5,
          "&.Mui-selected, &.Mui-selected:hover": {
            bgcolor: EVOTRUX_BLUE_LIGHT,
          },
        }}
      >
        <Checkbox
          edge="start"
          checked={checked}
          indeterminate={indeterminate}
          tabIndex={-1}
          disableRipple
          sx={{ "&:hover": { bgcolor: "transparent" } }}
          inputProps={{ "aria-label": ariaLabel }}
        />
        {children}
      </ListItemButton>
    </ListItem>
  );
}
